import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceVeryUnhappySVG = function FaceVeryUnhappySVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16 2A14 14 0 112 16 14 14 0 0116 2zm0 16a8.48 8.48 0 00-5.71 2.29 1 1 0 001.42 1.42 6.24 6.24 0 018.58 0 1 1 0 001.42-1.42A8.48 8.48 0 0016 18zm-4-7a2 2 0 102 2 2 2 0 00-2-2zm8 0a2 2 0 102 2 2 2 0 00-2-2z"
  }));
};
FaceVeryUnhappySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceVeryUnhappySVG);